import { produce, Draft } from 'immer'

import { CheckInFieldParameters, CountryTypeEnum, FieldCheckInTypeEnum, IdentityEnum, SelectedCheckin, StepperForm } from "../common/types/checkin";
import { reset } from 'ol/transform';

type State = {
  checkInFieldParameters: CheckInFieldParameters
  completionRates: any
  selected: SelectedCheckin
  stepperForm: StepperForm
  theData: {
    [value in IdentityEnum]?: CheckInFieldValue
  }
}

type CheckInFieldValue = {
  id: string
  customerAreaId: string
  customerFileId: string
  roomingId: string
  customerId: string
  civility: string
  lastName: string
  society: string
  firstName: string
  telephone: string
  mobile: string
  mobileCode: string
  mail: string
  birthDate: string
  birthPlace: string
  firstAddress: string
  secondaryAddress: string
  thirdAddress: string
  zipCode: string
  city: string
  country: string
  nationality: string
  language: string
  identityDocumentId: string
  identityDocument: string
}

const defautValueCheckInField = {
  id: '',
  customerAreaId: '',
  customerFileId: '',
  roomingId: '',
  customerId: '',
  civility: '',
  lastName: '',
  society: '',
  firstName: '',
  telephone: '',
  mobile: '',
  mobileCode: '',
  mail: '',
  birthDate: '',
  birthPlace: '',
  firstAddress: '',
  secondaryAddress: '',
  thirdAddress: '',
  zipCode: '',
  city: '',
  country: '',
  nationality: '',
  language: '',
  identityDocumentId: '',
  identityDocument: '',
}

const checkin = {
  state: {
    checkInFieldParameters: {},
    completionRates: {},
    selected: {
      bookingId: null,
      roomingListIndex: null,
      roomingListId: null,
    },
    stepperForm: {
      step: null,
      identity: null,
      countryType: null,
      fieldCheckInType: null, // TODO: move to selector property
    },
    theData: {
      [IdentityEnum.ResidentBase]: <CheckInFieldValue>{},
      [IdentityEnum.RoomingList]: <CheckInFieldValue>{},
    }
  } as State,
  reducers: {
    load: produce((draft: Draft<State>, payload: Partial<State>) => {

      Object.assign(draft, payload)
    }),
    handleSelected: produce((draft: Draft<State>, payload: Partial<SelectedCheckin>) => {
      Object.assign(draft.selected, payload)
    }),
    handleStepperForm: produce((draft: Draft<State>, payload: Partial<StepperForm>) => {

      Object.assign(draft.stepperForm, payload)

      const { identity, countryType } = draft.stepperForm
      // TODO: move to selector property
      if (identity && countryType) {
        const fieldCheckInType = getFieldCheckInType(identity, countryType)
        if (fieldCheckInType !== draft.stepperForm.fieldCheckInType) 
          draft.stepperForm.fieldCheckInType = fieldCheckInType
      }
    }),
    handleData: produce((draft: Draft<State>, payload: { [value in IdentityEnum]?: any }) => {

      if (payload?.resident) {
        Object.assign(draft.theData.resident, payload.resident)
      }

      if (payload?.roomingList) {
        Object.assign(draft.theData.roomingList, payload.roomingList)
      }
   
    }),
    resetData: produce((draft: Draft<State>) => {
      draft.theData[IdentityEnum.ResidentBase] = defautValueCheckInField;
      draft.theData[IdentityEnum.RoomingList] = defautValueCheckInField;
    })
  },
  effects: dispatch => ({
    async handleSelectedAsync(payload: Partial<SelectedCheckin>) {
      dispatch.checkin.handleSelected( payload );
      
    }
  })
}

const getFieldCheckInType = (identity: IdentityEnum, countryType: CountryTypeEnum): FieldCheckInTypeEnum => {
  if (identity === IdentityEnum.ResidentBase && countryType === CountryTypeEnum.Resident) {
    return FieldCheckInTypeEnum.Resident
  }
  if (identity === IdentityEnum.RoomingList && countryType === CountryTypeEnum.Resident) {
    return FieldCheckInTypeEnum.ResidentRooming
  } 
  if (identity === IdentityEnum.ResidentBase && countryType === CountryTypeEnum.NonResident) {
    return FieldCheckInTypeEnum.NonResident
  }

  return FieldCheckInTypeEnum.NonResidentRooming
}

/*// handle mobileCode depending on country Value
//TODO find the correct value of mobileCode with the countryValue
const setMobileCode = (payload, paxData) => {
  if (payload.country !== "" && paxData.mobileCode === "") {
    //get the correct mobileCodeValue with country
  }
}*/

// Gestion des données récupérer lors de chaque appel Ajax pour retransformation des données au format initial
// TODO: a optimiser plus tard
export const handleCheckinData = (data) => {
  if (data.bookings.length > 0){
    data.bookings.forEach(booking => {
      if (data.bookingPaxes.length > 0){
        let roomingList = data.bookingPaxes.filter(pax => pax.bookingId === booking.id);
        if (data.completionRates.length > 0 && roomingList.length > 0){
          roomingList.forEach((roomingData) => {
            return roomingData.completionRate = data.completionRates.find(completionRate => completionRate.bookingPaxId === roomingData.id).rate;
          });
        }
        booking.roomingList = roomingList;
      }
      if (data.accommodationServices.length > 0){
        booking.roomType = data.accommodationServices.find(accommodationService => accommodationService.id === booking.accommodationServiceId).name;
      }
      // adrien room
      if( booking.idRoom > 0 && data.rooms?.[booking.idRoom] ){
        booking.nameRoom = data.rooms?.[booking.idRoom]
      }
      return booking;
    });
    return data;
  }
  return false;
};

export default checkin